import { useMemo } from 'react';

import { shallowEqual, useSelector } from 'react-redux';

import {
  ActiveSubscriptionFragment,
  UserProfileFragment,
} from 'graphql/generated/graphql';

import { isActiveSubscription } from 'helpers/subscription';

import ReduxState from 'store/ReduxState';

export const useAuth = () => {
  const isAuthenticated = useSelector<ReduxState, boolean>(
    ({ auth }) => auth.isAuthenticated,
    shallowEqual,
  );
  const subscriptionExpiresAt = useSelector<
    ReduxState,
    string | null | undefined
  >(({ profile }) => profile.user?.subscriptionExpiresAt, shallowEqual);

  const hasPremiumAccess = useMemo(
    () => isActiveSubscription(subscriptionExpiresAt || undefined),
    [subscriptionExpiresAt],
  );

  const user = useSelector<ReduxState, UserProfileFragment | undefined>(
    ({ profile }) => profile.user,
    shallowEqual,
  );

  const activeSubscription = useSelector<
    ReduxState,
    ActiveSubscriptionFragment | undefined
  >(
    ({ profile }) => profile.user?.activeSubscription || undefined,
    shallowEqual,
  );

  return {
    activeSubscription,
    isAuthenticated,
    hasPremiumAccess,
    user,
  };
};
